import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "editing-disabled"
}
const _hoisted_2 = { class: "show-value" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "column"
}
const _hoisted_6 = {
  key: 0,
  class: "span-error"
}
const _hoisted_7 = {
  key: 1,
  class: "span-error"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["type", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!

  return (!_ctx.editing)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isModelEmpty)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('editable.input.nodata')), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.modelValue), 1))
        ]),
        _createVNode(_component_ButtonBlue, {
          class: "btn",
          text: _ctx.$t('editable.input.edit'),
          "on-click": _ctx.enableEditing
        }, null, 8, ["text", "on-click"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.mdp && !_ctx.isMdpLengthValid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('modale.my.account.contact.password.invalid.length')), 1))
          : _createCommentVNode("", true),
        (_ctx.mdp && !_ctx.isMdpValid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('modale.my.account.contact.password.invalid.caractere')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["input-container", {disabled: _ctx.isSaving}])
          }, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["text-input", {disabled: _ctx.isSaving}]),
              type: _ctx.mdp ? 'password' : 'tel',
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tempValue) = $event)),
              required: "",
              disabled: _ctx.isSaving
            }, null, 10, _hoisted_9), [
              [_vModelDynamic, _ctx.tempValue]
            ])
          ], 2),
          _createVNode(_component_ButtonBlue, {
            class: "btn",
            text: _ctx.$t('editable.input.save'),
            "on-click": _ctx.saveEdit,
            disabled: _ctx.saveButtonDisabled
          }, null, 8, ["text", "on-click", "disabled"]),
          _createVNode(_component_ButtonBlue, {
            class: "btn",
            text: _ctx.$t('editable.input.cancel'),
            "on-click": _ctx.cancelEditing,
            disabled: _ctx.isSaving
          }, null, 8, ["text", "on-click", "disabled"])
        ])
      ]))
}